import * as React from 'react';
import { AuthContext, DataContext, NeighbourContext } from '../../contexts/contexts';
import { Card, CardContent, Typography } from '@mui/material';


const floating = {
    position: 'absolute',
    left: 20,
    bottom: 150,
    opacity: 0.8,
    borderRadius: 4,
}

export default function DebugInfoViewer() {
    const authContextValue = React.useContext(AuthContext);
    const neighbourContextValue = React.useContext(NeighbourContext);
    const dataContextValue = React.useContext(DataContext);

  return (
    <Card elevation={4} sx={floating}>
        <CardContent>
            <Typography fontWeight={"bold"}>Auth</Typography>
            <Typography variant="subtitle2">{`Loading: ${authContextValue.loading}`}</Typography>
        </CardContent>
        <CardContent>
            <Typography fontWeight={"bold"}>Neighbour</Typography>
            <Typography variant="subtitle2">{`Loading: ${neighbourContextValue.loading}`}</Typography>
            <Typography variant="subtitle2">{`Neighbour ID: ${neighbourContextValue.neighbourData?.id}`}</Typography>
            <Typography variant="subtitle2">{`Community ID: ${neighbourContextValue.communityData?.id}`}</Typography>
            <Typography variant="subtitle2">{`# Facilities: ${neighbourContextValue.communityData?.facilities?.length}`}</Typography>
            <Typography variant="subtitle2">{`# Neighbours: ${neighbourContextValue.communityData?.neighbours?.length}`}</Typography>
            <Typography variant="subtitle2">{`# Properties: ${neighbourContextValue.communityData?.properties?.length}`}</Typography>
        </CardContent>
        <CardContent>
            <Typography fontWeight={"bold"}>Data</Typography>
            <Typography variant="subtitle2">{`Loading: ${dataContextValue.loading}`}</Typography>
            <Typography variant="subtitle2">{`# Announces (data/comm): ${dataContextValue.announcesData?.length}/${neighbourContextValue.communityData?.announces?.length} [${dataContextValue.allAnnouncesLoaded ? 'All loaded' : 'Pending'}]`}</Typography>
            <Typography variant="subtitle2">{`# Deliveries (data/comm): ${dataContextValue.deliveriesData?.length}/${neighbourContextValue.communityData?.deliveries?.length} [${dataContextValue.allDeliveriesLoaded ? 'All loaded' : 'Pending'}]`}</Typography>
            <Typography variant="subtitle2">{`# Meetings (data/comm): ${dataContextValue.meetingsData?.length}/${neighbourContextValue.communityData?.meetings?.length} [${dataContextValue.allMeetingsLoaded ? 'All loaded' : 'Pending'}]`}</Typography>
            <Typography variant="subtitle2">{`# Tickets (data/comm): ${dataContextValue.ticketsData?.length}/${neighbourContextValue.communityData?.tickets?.length} [${dataContextValue.allTicketsLoaded ? 'All loaded' : 'Pending'}]`}</Typography>
            
        </CardContent>
    </Card>
  )
}